module.exports = __webpack_public_path__ + "static/img/icon_04.bfd7aee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/icon_04.png
// module id = zLDy
// module chunks = 0